import React from 'react';
import classnames from 'classnames'
import styles from './statusBadge.module.less';

export default function StatusBadge(props) {
  return (
    <div
      style={props.style}
      className={classnames(styles.statusBadge, props.className)}>{props.children}</div>
  );
}
